import { css } from '@emotion/react';

export const welcomeCss = css`
  .invitation-welcome-header {
    position: relative;
    margin: -20px -20px 20px -20px;
    padding: 20px 20px 0 20px;

    width: 100%;
    height: 159px;
  }
`;

export const formCss = css`
  .invitation-form-header {
    margin-bottom: 20px;

    > *:not(:last-child) {
      margin-bottom: 4px;
    }
  }
`;
